import { render, staticRenderFns } from "./TransferFundsReview.vue?vue&type=template&id=1ae4ce22"
import script from "./TransferFundsReview.vue?vue&type=script&lang=js"
export * from "./TransferFundsReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports